import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Breadcrumbs from "react-router-dynamic-breadcrumbs";
import { Dropdown } from "react-bootstrap";
import { Link, withRouter } from "react-router-dom"; // Added withRouter
import PropTypes from "prop-types";

import STRINGS from "Constants/Strings";
import FIInformation from "Constants/FIInformation";
import * as ROUTES from "Constants/Routes";
import AppConstants from "Constants/AppConstants";
import {
  HTTP_STATUS,
  TOKEN_KEY,
  VAULT_PASSWORD,
  S_CURRENT_MEMBER_ID,
} from "Communication/Constants";
import Vault from "Components/Vault/Vault";
import FeedbackBanner from "Components/Common/FeedbackBanner/FeedbackBanner";
import {
  showFeedbackBanner,
  hideFeedbackBanner,
} from "Components/Common/FeedbackBanner/Actions/FeedbackBannerActions";
import doLogout from "Redux/Actions/LogoutAction";
import FundingReviewWindow from "../FundingReviewWindow/FundingReviewWindow";

import "./Header.scss";
import PopupModal from "../PopupModal/PopupModal";
import { S_CURRENT_MEMBER_NAME } from "../../../Communication/Constants";
import {
  SMART_BRANCH_DASHBOARD,
  SMART_BRANCH_REGISTER,
  VAULT_DASHBOARD,
} from "../../../Constants/Routes";
import { isInBranchFlow } from "../../../Utils/LogicUtilities";

// ToDo : Create another component for CustomToggle
const CustomToggle = React.forwardRef(({ onClick }, ref) => (
  <div
    ref={ref}
    onKeyDown={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    role="presentation"
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <div className="[ icon header-elipse-icon ]" />
  </div>
));

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: ROUTES.BREADCRUMBS,
      showWarning: false,
      showBanner: true,
      isMobileOrTablet: window.matchMedia("(max-width: 1199.98px)").matches,
    };
  }

  componentDidMount() {
    this.removeDuplicatesFromBreadcrumbs();

    // Set up media query listener for responsiveness
    this.mediaQueryList = window.matchMedia("(max-width: 1199.98px)");
    this.mediaQueryList.addEventListener("change", this.handleMediaQueryChange);
  }

  componentWillUnmount() {
    if (this.mediaQueryList) {
      this.mediaQueryList.removeEventListener(
        "change",
        this.handleMediaQueryChange
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { activeRoute, memberName } = this.props;
    if (
      prevProps.activeRoute !== activeRoute ||
      prevProps.memberName !== memberName
    ) {
      this.removeDuplicatesFromBreadcrumbs();
    }
  }

  handleMediaQueryChange = (e) => {
    this.setState({ isMobileOrTablet: e.matches });
  };

  /**
   * When we are on the Market place or Dashboard page we dont need the home
   * breadcrumb again but on other pages we need it.
   * So just on Market place and Dashboard pages we are removing the home breadcrumb
   */
  removeDuplicatesFromBreadcrumbs = () => {
    const { activeRoute, memberName } = this.props;
    console.log(
      "removeDuplicatesFromBreadcrumbs",
      activeRoute,
      sessionStorage.getItem(S_CURRENT_MEMBER_ID)
    );
    let updatedBreadcrumbs = { ...ROUTES.BREADCRUMBS };

    if (
      activeRoute === ROUTES.MARKETPLACE ||
      activeRoute === ROUTES.VAULT_DASHBOARD
    ) {
      console.log(
        "Removing home breadcrumb for MarketPlace or Vault Dashboard",
        activeRoute
      );
      if (
        activeRoute.includes(SMART_BRANCH_REGISTER) ||
        sessionStorage.getItem(S_CURRENT_MEMBER_ID)
      ) {
        console.log(
          "Adding home breadcrumb for Smart Branch Register or Current Member ID"
        );
        updatedBreadcrumbs[ROUTES.HOME] =
          STRINGS.BRANCH.BREADCRUMB.MEMBER +
          (!!sessionStorage.getItem(S_CURRENT_MEMBER_NAME)
            ? ` > ${sessionStorage.getItem(S_CURRENT_MEMBER_NAME)}`
            : "");
        updatedBreadcrumbs[ROUTES.VAULT_DASHBOARD] = "Marketplace";
      } else {
        delete updatedBreadcrumbs[ROUTES.HOME];
      }
    } else {
      const accessToken = sessionStorage.getItem("token");
      if (accessToken) {
        updatedBreadcrumbs = { ...ROUTES.BREADCRUMBS };
        if (activeRoute.includes(VAULT_PASSWORD)) {
          updatedBreadcrumbs[ROUTES.HOME] = STRINGS.MARKETPLACE.TITILE;
        } else if (
          memberName // if used directly by MemberScreen
        ) {
          console.log("membername used directly");
          if (activeRoute === ROUTES.SMART_BRANCH_DASHBOARD) {
            updatedBreadcrumbs[
              ROUTES.HOME
            ] = `${STRINGS.BRANCH.BREADCRUMB.MEMBER}`;
            updatedBreadcrumbs[ROUTES.SMART_BRANCH_DASHBOARD] = memberName;
          } else {
            updatedBreadcrumbs[ROUTES.HOME] =
              STRINGS.BRANCH.BREADCRUMB.MEMBER +
              (!!sessionStorage.getItem(S_CURRENT_MEMBER_NAME)
                ? ` > ${sessionStorage.getItem(S_CURRENT_MEMBER_NAME)}`
                : "");
          }
        } else if (
          activeRoute.includes(SMART_BRANCH_REGISTER) ||
          sessionStorage.getItem(S_CURRENT_MEMBER_ID)
        ) {
          console.log("setting member name in breadcrumbs");
          updatedBreadcrumbs[ROUTES.HOME] =
            STRINGS.BRANCH.BREADCRUMB.MEMBER +
            (!!sessionStorage.getItem(S_CURRENT_MEMBER_NAME)
              ? ` > ${sessionStorage.getItem(S_CURRENT_MEMBER_NAME)}`
              : "");
        } else {
          updatedBreadcrumbs[ROUTES.HOME] = STRINGS.HOME_BREADCRUMB;
        }
      }
    }
    console.log("Updated breadcrumbs:", updatedBreadcrumbs);
    this.setState({ breadcrumbs: updatedBreadcrumbs });
  };

  getActiveHeaderFromRoute = (activeRoute) => {
    if (activeRoute.includes(ROUTES.RECOVER_PASSWORD)) {
      return ROUTES.BREADCRUMBS[ROUTES.RECOVER_PASSWORD];
    }
    return ROUTES.BREADCRUMBS[activeRoute];
  };

  signOut = () => {
    const { inSessionJointApplicant } = this.props;
    console.log("signOut", window.location);
    if (
      inSessionJointApplicant &&
      !window.location.href.endsWith(ROUTES.JOINT_APPLICANT_STATUS)
    ) {
      this.setState({ showWarning: true });
    } else {
      this.continueSignOut();
    }
  };

  continueSignOut = () => {
    const { doLogoutAction, history } = this.props;
    if (isInBranchFlow()) {
      doLogoutAction((res) => {
        if (res.status === HTTP_STATUS.OK) {
          window.location.href = ROUTES.SMART_BRANCH;
          //history.push(ROUTES.MARKETPLACE);
        }
      });
    } else {
      doLogoutAction((res) => {
        if (res.status === HTTP_STATUS.OK) {
          window.location.href = ROUTES.MARKETPLACE;
          //history.push(ROUTES.MARKETPLACE);
        }
      });
    }
  };

  changePassword = () => {
    const { history } = this.props;
    history.push(ROUTES.CHANGE_PASSWORD);
  };

  closeMenu = () => {};

  getActiveProduct = (products) => {
    return products?.find((product) => product?.active);
  };

  dropdownToggle = (e) => {
    const { showVaultClicked, showVault } = this.props;
    if (e && showVault) {
      showVaultClicked();
    }
  };

  toggleWarning = () => {
    this.setState({
      showWarning: false,
    });
  };

  render() {
    const accessToken = sessionStorage.getItem(TOKEN_KEY);
    const {
      showVault,
      activeRoute,
      history,
      vaultProductList,
      activeTab,
      FundState,
      fundProduct,
      showFundAccount,
      showFundVaultClicked,
      showVaultClicked,
      products,
      bankingType,
      switchBanking,
      handleSignIn,
      handleRegister,
      isQrKyc,
      location,
    } = this.props;
    console.log("active route", activeRoute);
    const { showWarning } = this.state;

    const activeProduct = this.getActiveProduct(products);

    const { method, amount } = FundState;

    const { breadcrumbs } = this.state;
    let popUpVault = null;
    if (showVault) {
      console.log("show vault");
      popUpVault = (
        <div
          className={
            isInBranchFlow()
              ? "[ branch-summary small-vault-container ]"
              : "[ small-vault-container ]"
          }
        >
          <Vault
            showProceedBtn={
              activeRoute === ROUTES.MARKETPLACE ||
              activeRoute === ROUTES.VAULT_DASHBOARD ||
              activeRoute === ROUTES.QUESTIONNAIRE
            }
            showVaultClicked={showVaultClicked}
            history={history}
          />
        </div>
      );
    } else if (showFundAccount) {
      popUpVault = (
        <div className="[ small-vault-container ]">
          <FundingReviewWindow
            fundMethod={method}
            fundAmount={amount}
            productName={fundProduct.productName}
            showFundVaultClicked={showFundVaultClicked}
          />
        </div>
        // <Backdrop show={showVault} clicked={showVaultClicked} top />
      );
    }
    let activeHeader = this.getActiveHeaderFromRoute(activeRoute);
    console.log("activeHeader", activeHeader);
    console.log("activeRoute", activeRoute);
    if (
      activeRoute === ROUTES.EXISTING_MEMBER ||
      activeRoute === ROUTES.MEMBER_CREATION ||
      activeRoute === ROUTES.BEFORE_WE_START ||
      activeRoute === ROUTES.GETTING_STARTED ||
      activeRoute === ROUTES.ABOUT_YOU ||
      activeRoute === ROUTES.EMPLOYMENT_AND_INCOME ||
      activeRoute === ROUTES.TAX_INFO ||
      activeRoute === ROUTES.COMPLIANCE ||
      activeRoute === ROUTES.CHANGE_PASSWORD
    ) {
      activeHeader = STRINGS.HEADER.MEMBER_INFO;
    } else if (
      activeRoute === ROUTES.ONLINE_BANKING ||
      activeRoute === ROUTES.FUND_METHOD ||
      activeRoute === ROUTES.FUNDING_AMOUNT ||
      activeRoute === ROUTES.SIGNATURE
    ) {
      if (fundProduct?.productName) {
        activeHeader = fundProduct.productName;
      } else {
        activeHeader = activeProduct?.productName;
      }
    } else if (
      activeRoute === ROUTES.REGISTER ||
      activeRoute === ROUTES.VERIFICATION_CODE ||
      activeRoute === ROUTES.VAULT_PASSWORD
    ) {
      activeHeader = STRINGS.HEADER.REGISTRATION;
    } else if (activeRoute === ROUTES.SIGN_IN) {
      activeHeader = STRINGS.HEADER.SIGNIN;
    } else if (
      activeRoute === ROUTES.FORGOT_PASSWORD ||
      activeRoute === ROUTES.SIGNIN_FORGOT_VERIFICATION ||
      activeRoute === ROUTES.RECOVER_PASSWORD_BY_EMAIL ||
      activeRoute === ROUTES.SIGNIN_FORGOT_VERIFICATION_VAULT_PASSWORD
    ) {
      activeHeader = STRINGS.HEADER.FORGOTPASSWORD;
    } else if (
      activeProduct &&
      activeRoute !== ROUTES.MARKETPLACE &&
      activeRoute !== ROUTES.VAULT_DASHBOARD
    ) {
      activeHeader = activeProduct.productName;
    } else if (
      !activeHeader &&
      (activeRoute === ROUTES.SMART_BRANCH ||
        activeRoute === ROUTES.SMART_BRANCH_DASHBOARD)
    ) {
      activeHeader = STRINGS.BRANCH.TITLE;
    } else if (activeRoute === ROUTES.SMART_BRANCH_REGISTER) {
      activeHeader = STRINGS.BRANCH.TITLE;
    }

    let isShowVaultIcon = true;
    if (activeRoute === ROUTES.VAULT_DASHBOARD) {
      if (activeTab === 0) {
        isShowVaultIcon = false;
      }
    }

    const isShowSignOut = accessToken && !activeRoute.includes(VAULT_PASSWORD);
    const { feedbackBanner, hideFeedbackBanner, memberName } = this.props;
    const { isMobileOrTablet } = this.state;

    return (
      <>
        {showWarning && (
          <PopupModal
            type={AppConstants.MODALTYPE.INFORMATION}
            title="You are almost there! For security purposes, we do not store any sensitive personal information about your co-applicant. "
            description="If you log out now, your co-applicant information will need to be re-submitted. We recommend you complete the application during this session to save time."
            toggleModal={this.toggleWarning}
            showModal={showWarning}
            popupBtnClick={this.toggleWarning}
            closeBtnClick={this.toggleWarning}
            customBtnClick={this.continueSignOut}
            customBtnText="Continue Logout"
            btnText="Complete the Application"
          />
        )}
        <header>
          {isMobileOrTablet && feedbackBanner.show && (
            <FeedbackBanner
              show={feedbackBanner.show}
              message={feedbackBanner.message}
              variant={feedbackBanner.variant}
              onClose={hideFeedbackBanner}
            />
          )}
          <div className="[ container-fluid ] [ header-container ]">
            <div className="[ row ]">
              <div className="[ d-flex ] [ w-100 ] [ justify-content-between align-items-xl-center ] [ header-row ]">
                <div className="[ logo ]" />
                <div className="[ page-header ]">
                  {activeRoute || activeHeader !== ""
                    ? activeHeader
                    : STRINGS.HEADER.SIGNINTITLE}
                </div>

                <div className="[ d-flex flex-row d-xl-none ] [ pt-2 ] [ header-container__item vault-icon-container ]">
                  {/* CHRIS NOTE: Hacks inplace to support existing global nav bar. Should and will refactor at later date to use button group + dropdowns. */}
                  {(activeRoute === ROUTES.FUNDING_AMOUNT ||
                    activeRoute === ROUTES.FUND_METHOD) && (
                    <div
                      className={
                        showFundAccount
                          ? "[ fund-account-image opened ]"
                          : "[ fund-account-image ]"
                      }
                      onClick={showFundVaultClicked}
                      role="presentation"
                    />
                  )}
                  {activeRoute !== ROUTES.FUNDING_AMOUNT &&
                    activeRoute !== ROUTES.FUND_METHOD &&
                    !isQrKyc &&
                    isShowVaultIcon &&
                    vaultProductList &&
                    vaultProductList.length !== 0 && (
                      <span className="[ ic-circle vault-circle ]">
                        {vaultProductList.length}
                      </span>
                    )}
                  {isShowVaultIcon && !isQrKyc && (
                    <div
                      className={
                        showVault ? "[ vault-image opened ]" : "[ vault-image ]"
                      }
                      onClick={showVaultClicked}
                      role="presentation"
                    />
                  )}
                  <Dropdown onToggle={this.dropdownToggle}>
                    <Dropdown.Toggle
                      as={CustomToggle}
                      id="dropdown-custom-components"
                    />
                    {isShowSignOut && (
                      <Dropdown.Menu
                        size="sm"
                        title="Navigation options"
                        className="[ global_nav_drawer ] [ signed-in ]"
                      >
                        <div className="[ global_nav_drawer__inner-container ]">
                          <div className="[ vault-header__container ]">
                            <h4 className="[ form-subtitle ]">
                              <i className="[ fas fa-bars ]" />

                              {STRINGS.HEADER.GLOBALNAV.TITLE}
                              <Dropdown.Item
                                eventKey="1"
                                className="[ d-inline p-0 ]"
                              >
                                <button
                                  type="button"
                                  className="[ close ]"
                                  onClick={this.closeMenu}
                                >
                                  <span aria-hidden="true">×</span>
                                  <span className="[ sr-only ]">Close</span>
                                </button>
                              </Dropdown.Item>
                            </h4>
                          </div>

                          {!isQrKyc && !isInBranchFlow() && (
                            <>
                              <Dropdown.Item
                                eventKey="1"
                                onClick={this.signOut}
                              >
                                {STRINGS.HEADER.GLOBALNAV.SIGNOUT}{" "}
                                <span className="[ icon ] [ product-navigation-icon ]" />
                              </Dropdown.Item>

                              <Dropdown.Divider />

                              <Dropdown.Header>
                                {STRINGS.HEADER.GLOBALNAV.SETTINGS}
                              </Dropdown.Header>

                              <Dropdown.Item onClick={this.changePassword}>
                                {STRINGS.HEADER.GLOBALNAV.CHANGEPASSWORD}{" "}
                                <span className="[ icon ] [ product-navigation-icon ]" />
                              </Dropdown.Item>

                              <Dropdown.Divider />
                            </>
                          )}

                          <Dropdown.Header>
                            {STRINGS.HEADER.GLOBALNAV.LEGALESE}
                          </Dropdown.Header>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_PRIVACY}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.PRIVACY}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_CONDITIONS}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.CONDITIONS}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>

                          <Dropdown.Divider />

                          <Dropdown.Header>
                            {STRINGS.HEADER.GLOBALNAV.CONTACTUS}
                          </Dropdown.Header>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_SITE}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.COMPANYSITE}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_EMAIL}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.CUSTOMERSERVICE}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>
                        </div>
                      </Dropdown.Menu>
                    )}
                    {!isShowSignOut && (
                      <Dropdown.Menu
                        size="sm"
                        title="Navigation options"
                        className="[ global_nav_drawer ] [ signed-out ]"
                      >
                        <div className="[ global_nav_drawer__inner-container ]">
                          <div className="[ vault-header__container ]">
                            <h4 className="[ form-subtitle ]">
                              <i className="[ fas fa-bars ]" />

                              {STRINGS.HEADER.GLOBALNAV.TITLE}
                              <Dropdown.Item
                                eventKey="1"
                                className="[ d-inline p-0 ]"
                              >
                                <button
                                  type="button"
                                  className="[ close ]"
                                  onClick={this.closeMenu}
                                >
                                  <span aria-hidden="true">×</span>
                                  <span className="[ sr-only ]">Close</span>
                                </button>
                              </Dropdown.Item>
                            </h4>
                          </div>

                          <Dropdown.Header>
                            {STRINGS.HEADER.GLOBALNAV.LEGALESE}
                          </Dropdown.Header>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_PRIVACY}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.PRIVACY}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_CONDITIONS}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.CONDITIONS}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>

                          <Dropdown.Divider />

                          <Dropdown.Header>
                            {STRINGS.HEADER.GLOBALNAV.CONTACTUS}
                          </Dropdown.Header>
                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_SITE}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.COMPANYSITE}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_EMAIL}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.CUSTOMERSERVICE}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>
                        </div>
                      </Dropdown.Menu>
                    )}
                  </Dropdown>
                </div>

                <div className="[ d-none d-xl-flex flex-row ] [ mr-xl-5 ] [ header-container__item drop-mobile-menu ]">
                  {isShowSignOut && isInBranchFlow() && (
                    <>
                      <div
                        className="[ pt-3 ] [ welcome-user-text ]"
                        style={{ paddingRight: 10 }}
                      >
                        <i className="[ fas fa-user-friends ]"></i>
                        &nbsp;Colleagues
                      </div>
                      <div
                        className="[ pt-3 ] [ welcome-user-text ]"
                        style={{ paddingRight: 10 }}
                      >
                        <i className="[ fas fa-bell ]"></i>
                        &nbsp;Alerts
                      </div>
                    </>
                  )}

                  <div className="[ pt-3 ] [ welcome-user-text ]">
                    <div className="[ icon welcome-user-icon ]">
                      {STRINGS.HEADER.WELCOME}
                    </div>
                  </div>
                  {isShowSignOut && (
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="link"
                        id="dropdown-basic"
                        className="[ pt-3 ]"
                      />

                      <Dropdown.Menu className="[ signed-in ]">
                        <Dropdown.Item eventKey="1" onClick={this.signOut}>
                          {STRINGS.HEADER.GLOBALNAV.SIGNOUT}{" "}
                          <span className="[ icon ] [ product-navigation-icon ]" />
                        </Dropdown.Item>

                        {!isInBranchFlow() && (
                          <>
                            <Dropdown.Divider />

                            <Dropdown.Header>
                              {STRINGS.HEADER.GLOBALNAV.SETTINGS}
                            </Dropdown.Header>

                            <Dropdown.Item onClick={this.changePassword}>
                              {STRINGS.HEADER.GLOBALNAV.CHANGEPASSWORD}{" "}
                              <span className="[ icon ] [ product-navigation-icon ]" />
                            </Dropdown.Item>

                            <Dropdown.Divider />

                            <Dropdown.Header>
                              {STRINGS.HEADER.GLOBALNAV.LEGALESE}
                            </Dropdown.Header>

                            <Dropdown.Item
                              tag={Link}
                              href={FIInformation.FI_PRIVACY}
                              target="_blank"
                            >
                              {STRINGS.HEADER.GLOBALNAV.PRIVACY}{" "}
                              <span className="[ icon ] [ product-navigation-icon ]" />
                            </Dropdown.Item>

                            <Dropdown.Item
                              tag={Link}
                              href={FIInformation.FI_CONDITIONS}
                              target="_blank"
                            >
                              {STRINGS.HEADER.GLOBALNAV.CONDITIONS}{" "}
                              <span className="[ icon ] [ product-navigation-icon ]" />
                            </Dropdown.Item>

                            <Dropdown.Divider />

                            <Dropdown.Header>
                              {STRINGS.HEADER.GLOBALNAV.CONTACTUS}
                            </Dropdown.Header>
                            <Dropdown.Item
                              tag={Link}
                              href={FIInformation.FI_SITE}
                              target="_blank"
                            >
                              {STRINGS.HEADER.GLOBALNAV.COMPANYSITE}{" "}
                              <span className="[ icon ] [ product-navigation-icon ]" />
                            </Dropdown.Item>

                            <Dropdown.Item
                              tag={Link}
                              href={FIInformation.FI_EMAIL}
                              target="_blank"
                            >
                              {STRINGS.HEADER.GLOBALNAV.CUSTOMERSERVICE}
                              <span className="[ icon ] [ product-navigation-icon ]" />
                            </Dropdown.Item>
                          </>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  )}
                  {!isShowSignOut && (
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="link"
                        id="dropdown-basic"
                        className="[ pt-3 ]"
                      />
                      {isInBranchFlow() && (
                        <Dropdown.Menu className="[ signed-out ]">
                          <Dropdown.Item onClick={handleSignIn}>
                            {STRINGS.HEADER.GLOBALNAV.SIGNIN}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      )}
                      {!isInBranchFlow() && (
                        <Dropdown.Menu className="[ signed-out ]">
                          <Dropdown.Header>
                            {STRINGS.HEADER.GLOBALNAV.PARENT_MARKETPLACE.split(
                              "_BANKING_TYPE_"
                            ).join(bankingType)}
                          </Dropdown.Header>
                          <Dropdown.Item onClick={handleSignIn}>
                            {STRINGS.HEADER.GLOBALNAV.SIGNIN}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>
                          <Dropdown.Item onClick={handleRegister}>
                            {STRINGS.HEADER.GLOBALNAV.REGISTER}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>
                          <Dropdown.Divider />

                          <Dropdown.Header>
                            {STRINGS.HEADER.GLOBALNAV.LEGALESE}
                          </Dropdown.Header>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_PRIVACY}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.PRIVACY}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_CONDITIONS}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.CONDITIONS}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>

                          <Dropdown.Divider />

                          <Dropdown.Header>
                            {STRINGS.HEADER.GLOBALNAV.CONTACTUS}
                          </Dropdown.Header>
                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_SITE}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.COMPANYSITE}{" "}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>

                          <Dropdown.Item
                            tag={Link}
                            href={FIInformation.FI_EMAIL}
                            target="_blank"
                          >
                            {STRINGS.HEADER.GLOBALNAV.CUSTOMERSERVICE}
                            <span className="[ icon ] [ product-navigation-icon ]" />
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      )}
                    </Dropdown>
                  )}
                </div>
              </div>
            </div>
          </div>
          {popUpVault}
          {((!isQrKyc &&
            window.location.pathname !== ROUTES.SMART_BRANCH &&
            window.location.pathname !== ROUTES.SMART_BRANCH_DASHBOARD) ||
            !!memberName) && (
            <div className="[ breadcrumb-container ]">
              <Breadcrumbs
                WrapperComponent={(wrappedCompProps) => (
                  <ol className="[ breadcrumb ]">
                    {wrappedCompProps.children}
                  </ol>
                )}
                ActiveLinkComponent={(activeLinkCompProps) => (
                  <li className="[ breadcrumb-icon ] [ active ]">
                    {activeLinkCompProps.children}
                  </li>
                )}
                LinkComponent={(linkCompProps) => {
                  console.log("linkCompProps", linkCompProps);
                  if (
                    linkCompProps.children.props.children ===
                    "Verification Code"
                  ) {
                    return "";
                  } else if (
                    linkCompProps.children.props.children ===
                    "Online Marketplace"
                  ) {
                    // Clone the children and modify the 'to' prop
                    const modifiedChildren = React.cloneElement(
                      linkCompProps.children,
                      {
                        ...linkCompProps.children.props,
                        to: "/marketplace",
                      }
                    );
                    return (
                      <li className="[ breadcrumb-icon ]">
                        {modifiedChildren}
                      </li>
                    );
                  } else {
                    return (
                      <li className="[ breadcrumb-icon ]">
                        {linkCompProps.children}
                      </li>
                    );
                  }
                }}
                mappedRoutes={breadcrumbs}
                routeMatcherRegex={AppConstants.HEADER.matchRoutePattern}
              />
            </div>
          )}
        </header>
      </>
    );
  }
}

Header.propTypes = {
  showVault: PropTypes.bool,
  showVaultClicked: PropTypes.func,
  activeRoute: PropTypes.string,
  doLogoutAction: PropTypes.func,
  history: PropTypes.oneOfType([PropTypes.object]),
  vaultProductList: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.string,
  ]).isRequired,
  activeTab: PropTypes.number.isRequired,
  FundState: PropTypes.oneOfType([PropTypes.object]),
  fundProduct: PropTypes.oneOfType([PropTypes.object]),
  showFundAccount: PropTypes.bool,
  showFundVaultClicked: PropTypes.func,
  products: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
  inSessionJointApplicant: PropTypes.bool,
  handleSignIn: PropTypes.func,
  handleRegister: PropTypes.func,
  isQrKyc: PropTypes.bool,
  bankingType: PropTypes.string,
  memberName: PropTypes.string,
  switchBanking: PropTypes.func,
  location: PropTypes.oneOfType([PropTypes.object]),
  feedbackBanner: PropTypes.shape({
    show: PropTypes.bool,
    message: PropTypes.string,
    variant: PropTypes.string,
  }),
  hideFeedbackBanner: PropTypes.func,
};

Header.defaultProps = {
  history: {},
  showVault: false,
  showVaultClicked: () => {},
  activeRoute: "",
  doLogoutAction: () => {},
  FundState: {},
  fundProduct: {},
  showFundAccount: false,
  showFundVaultClicked: () => {},
  products: [],
  inSessionJointApplicant: false,
  handleSignIn: () => {},
  handleRegister: () => {},
  isQrKyc: false,
  bankingType: "",
  memberName: "",
  switchBanking: () => {},
  location: {},
  feedbackBanner: {
    show: false,
    message: "",
    variant: "info",
  },
  hideFeedbackBanner: () => {},
};

CustomToggle.propTypes = {
  onClick: PropTypes.func,
};

CustomToggle.defaultProps = {
  onClick: () => {},
};

const mapStateToProps = (state) => ({
  vaultProductList: state.VaultReducer.vaultProductList,
  activeTab: state.MarketplaceReducer.activeTab,
  FundState: state.FundReducer,
  fundProduct: state.VaultReducer.fundProduct,
  products: state.VaultReducer.vaultProductList,
  inSessionJointApplicant: state.JoinApplicantReducer.inSessionJointApplicant,
  bankingType: state.MarketplaceReducer.bankingType,
  finInfo: state.MarketplaceReducer.finInfo,
  isQrKyc: state.ApplicationReducer.isQrKyc,
  feedbackBanner: state.feedbackBanner,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      doLogoutAction: doLogout,
      showFeedbackBanner,
      hideFeedbackBanner,
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
